export default __webpack_public_path__ + "static/media/expl_03_DE.d62fce99.png";